import React, { useState, useEffect } from "react";
import { Card, Table, Input, Button, Space, Tag, Typography, Row, Col, Empty } from "antd";
import { SearchOutlined, UserOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./Customers.scss";

const { Title, Text } = Typography;
const { Search } = Input;

const Customers = () => {
  const { t } = useTranslation();
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // TODO: Replace with actual API call
    // For now, using mock data
    setLoading(true);
    setTimeout(() => {
      // Mock data - replace with actual API call
      const mockCustomers = [];
      setCustomers(mockCustomers);
      setFilteredCustomers(mockCustomers);
      setLoading(false);
    }, 500);
  }, []);

  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setFilteredCustomers(customers);
      return;
    }

    const filtered = customers.filter(
      (customer) =>
        customer.name?.toLowerCase().includes(value.toLowerCase()) ||
        customer.email?.toLowerCase().includes(value.toLowerCase()) ||
        customer.phone?.includes(value)
    );
    setFilteredCustomers(filtered);
  };

  const columns = [
    {
      title: "שם",
      dataIndex: "name",
      key: "name",
      align: "right",
      render: (text) => (
        <Space>
          <UserOutlined />
          {text || "ללא שם"}
        </Space>
      ),
    },
    {
      title: "אימייל",
      dataIndex: "email",
      key: "email",
      align: "right",
      render: (text) => (
        <Space>
          <MailOutlined />
          {text || "ללא אימייל"}
        </Space>
      ),
    },
    {
      title: "טלפון",
      dataIndex: "phone",
      key: "phone",
      align: "right",
      render: (text) => (
        <Space>
          <PhoneOutlined />
          {text || "ללא טלפון"}
        </Space>
      ),
    },
    {
      title: "מספר הזמנות",
      dataIndex: "ordersCount",
      key: "ordersCount",
      align: "right",
      render: (count) => <Tag color="blue">{count || 0}</Tag>,
    },
    {
      title: "סטטוס",
      dataIndex: "status",
      key: "status",
      align: "right",
      render: (status) => {
        const statusConfig = {
          active: { color: "green", text: "פעיל" },
          inactive: { color: "default", text: "לא פעיל" },
        };
        const config = statusConfig[status] || statusConfig.inactive;
        return <Tag color={config.color}>{config.text}</Tag>;
      },
    },
  ];

  return (
    <div className="customers-page">
      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <Card>
            <Title level={2}>ניהול לקוחות</Title>
            <Text type="secondary">
              צפייה וניהול כלל הלקוחות שלך במערכת
            </Text>
          </Card>
        </Col>

        <Col xs={24}>
          <Card>
            <Space direction="vertical" style={{ width: "100%" }} size="large">
              <Search
                placeholder="חפש לקוח לפי שם, אימייל או טלפון..."
                allowClear
                enterButton={<SearchOutlined />}
                size="large"
                onSearch={handleSearch}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ maxWidth: 500 }}
              />

              {filteredCustomers.length === 0 && !loading ? (
                <Empty
                  description={
                    searchText
                      ? "לא נמצאו לקוחות התואמים לחיפוש"
                      : "אין לקוחות במערכת"
                  }
                />
              ) : (
                <Table
                  columns={columns}
                  dataSource={filteredCustomers}
                  rowKey="id"
                  loading={loading}
                  pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => `סה"כ ${total} לקוחות`,
                  }}
                  style={{ direction: "rtl" }}
                />
              )}
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Customers;
